import {
  AppBar,
  Box,
  Container,
  Grid,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useLocation } from '@reach/router';
import { Button, Link } from 'gatsby-theme-material-ui';
import React, { useEffect, useState } from 'react';
import { sendMyTargetEvent } from '../../../helpers/myTarget';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import CodeIcon from '../../../kit/icons/CodeIcon';
import StonksIcon from '../../../kit/icons/StonksIcon';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import { ChevronUpIcon } from '../icons/ChevronUpIcon';
// import NYelbrusLogo from './Elbrus-NY-logo-х2.png';
import { ElbrusRusLogoIcon } from '../icons/ElbrusRusLogoIcon';
import { styles } from './styles';
import JSsmallIcon from '../../../kit/icons/JSsmallIcon';
import AiProgramIcon from '../../../kit/icons/AiProgramIcon';
import PyIcon from '../../../kit/icons/PyIcon';
import { AiIcon } from '../../../kit/icons/AiIcon';

export const arrLinks = [
  {
    title: 'Программы',
    href: '/#program',
    isButton: true,
    myTargetEvent: 'MainProgramsTop',
  },
  {
    title: 'События',
    href: '/events/',
    canBeActive: true,
  },
  {
    title: 'О нас',
    href: '/about/',
    canBeActive: true,
  },

  {
    title: 'Блог',
    href: '/blog/',
    isExternal: true,
    canBeActive: false,
  },
  {
    title: 'Контакты',
    href: '/contacts/',
    canBeActive: true,
  },
  {
    title: 'F.A.Q.',
    href: '/faq/',
    canBeActive: true,
  },
];
export const settings = [
  [
    {
      title: 'Веб-разработчик',
      href: '/web-development/',
      Icon: CodeIcon,
      ymEvent: 'MainHeaderProgramJS',
      myTargetEvent: 'MainWebDevProgram',
    },
    {
      title: 'Data Science',
      href: '/datascience/',
      Icon: StonksIcon,
      ymEvent: 'MainHeaderProgramDS',
      myTargetEvent: 'MainDSProgram',
    },
  ],
  [
    {
      title: 'Основы JavaScript',
      href: '/javascript-basics/',
      Icon: JSsmallIcon,
    },
    {
      title: 'Основы Python',
      href: '/datascience-basics/',
      Icon: PyIcon,
    },
  ],
  [
    {
      title: 'AI для разработчиков',
      href: 'https://ai.elbrusboot.camp/',
      Icon: AiProgramIcon,
    },
  ],
];

export const MenuItemsSet = ({ settings, activePath, cbCloseMenu, index }) => {
  return (
    <>
      {settings.map(({ title, href, Icon, ymEvent, myTargetEvent }) => (
        <Grid
          key={title}
          container
          onClick={(event) => {
            event.stopPropagation();
          }}
          sx={{ cursor: 'pointer', padding: '4px 0' }}
        >
          {href && (
            <MenuItem
              key={title}
              sx={styles.menuItem}
              onClick={() => {
                sendMyTargetEvent(myTargetEvent);
                sendYandexMetrikaEvent(ymEvent);
                cbCloseMenu && cbCloseMenu();
              }}
            >
              <Link
                variant="desktopP3"
                href={href}
                target={href.startsWith('http') ? '_blank' : '_self'}
                sx={styles.menuItemLink}
              >
                <Icon
                  active={activePath !== '/' && href.includes(activePath)}
                />
                {title}
                {(index === 0 || index === 2) && (
                  <Box sx={styles.aiBadge}>
                    <AiIcon />
                    <Typography variant="mobileHelper">AI</Typography>
                  </Box>
                )}
              </Link>
            </MenuItem>
          )}
        </Grid>
      ))}
    </>
  );
};

const MenuItems = ({ settings, isOpen, handleClose, anchorEl, activePath }) => (
  <Menu
    disableScrollLock
    anchorEl={anchorEl}
    open={isOpen}
    onClose={handleClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    keepMounted
    disableAutoFocusItem
    sx={{
      transform: 'translate(82px, 20px)',
      '& .MuiList-root': {
        px: 2,
        py: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      },
    }}
  >
    {settings.map((settingsSet, index) => (
      <Box
        key={index}
        sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
      >
        <Typography
          variant="mobileP2"
          sx={{
            color: 'kit.text.secondary',
            letterSpacing: '-0.01em',
          }}
        >
          {index === 0
            ? 'Основные программы'
            : index === 1
              ? 'Подготовительные программы'
              : 'Повышение квалификации'}
        </Typography>
        <MenuItemsSet
          settings={settingsSet}
          activePath={activePath}
          index={index}
        />
      </Box>
    ))}
  </Menu>
);

export default function Navbar({ lkLinks }) {
  const location = useLocation();
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const currentUrl = location.pathname + location.hash;
  const [selectedItem, setSelectedItem] = useState(currentUrl);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMediaQueryReady, setIsMediaQueryReady] = useState(false);

  useEffect(() => {
    if (!isMediaQueryReady) {
      setIsMediaQueryReady(true);
    }
  }, [isMd]);

  const handleClick = (event, myTargetEvent) => {
    setAnchorEl(event.currentTarget);

    if (myTargetEvent) {
      sendMyTargetEvent(myTargetEvent);
    }
  };

  const isOpen = Boolean(anchorEl);

  const lkButtons = (
    <>
      <Link
        key={lkLinks.enter}
        variant="kitSecondary"
        target="_blank"
        underline="hover"
        href={lkLinks.enter}
        sx={styles.link}
      >
        <Button
          variant="outlined"
          size="smallest"
          onClick={() => sendMyTargetEvent('MainTrainerSignIn')}
        >
          Войти
        </Button>
      </Link>
      <Link
        key={lkLinks.demo}
        variant="kitSecondary"
        target="_blank"
        underline="hover"
        href={lkLinks.demo}
        sx={styles.link}
      >
        <Button
          variant="kitPrimary"
          size="smallest"
          onClick={() => sendMyTargetEvent('MainDemoTrainer')}
        >
          Начать учиться
        </Button>
      </Link>
    </>
  );

  return (
    <AppBar component="div" elevation={0} sx={styles.root}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar variant="dense" disableGutters sx={styles.toolbar}>
          <Link variant="desktopP3" href="/#top" underline="hover">
            {/* <img src={NYelbrusLogo} alt="Elbrus" style={{ width: '104px' }} /> */}
            <ElbrusRusLogoIcon sx={styles.elbrusLogoIcon} />
          </Link>
          <Box sx={styles.navbar}>
            {arrLinks.map((link) => {
              const [targetPathname, targetHash] = link.href.split('#');
              const isAnchor =
                location.pathname === targetPathname &&
                (targetHash || link.href.includes('#'));

              if (link.isButton) {
                return (
                  <Box sx={{ display: 'inline-flex' }} key={link.href}>
                    <Link
                      onClick={(event) =>
                        handleClick(event, link?.myTargetEvent)
                      }
                      variant="desktopP3"
                      underline="none"
                      sx={styles.link}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                      >
                        <Box sx={styles.programTitle}>
                          <Typography color={'kit.text.h'} variant="desktopP3">
                            {link.title}
                          </Typography>
                        </Box>
                        <ChevronUpIcon
                          color="kit.text.h"
                          sx={styles.chevronIcon(isOpen)}
                        />
                      </Box>
                    </Link>
                    <MenuItems
                      settings={settings}
                      isOpen={isOpen}
                      handleClose={() => setAnchorEl(null)}
                      anchorEl={anchorEl}
                      activePath={location.pathname}
                    />
                  </Box>
                );
              }

              return (
                <Link
                  key={link.href}
                  variant="desktopP3"
                  href={isAnchor || link.isExternal ? link.href : undefined}
                  to={!isAnchor && !link.isExternal ? link.href : undefined}
                  target={link.title === 'Блог' ? '_blank' : '_self'}
                  onClick={() => {
                    setSelectedItem(link.href);
                  }}
                  underline="hover"
                  sx={styles.navbarLinks(
                    (selectedItem === link.href && link.canBeActive) ||
                      (link.extraHref?.includes(selectedItem) &&
                        link.canBeActive),
                  )}
                >
                  {link.title}
                </Link>
              );
            })}
          </Box>
          {isMediaQueryReady && (
            <>
              {!isMd ? (
                <Box sx={styles.lkButtonsWrapper}>{lkButtons}</Box>
              ) : (
                <BurgerMenu lkLinks={lkLinks} lkButtons={lkButtons} />
              )}
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
